"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutDateRangeClick = void 0;
const react_1 = require("react");
const useOutDateRangeClick = (callback) => {
    const rootRef = (0, react_1.useRef)(null);
    const handleOutsideClickRef = (0, react_1.useRef)(() => { });
    handleOutsideClickRef.current = (event) => {
        var _a, _b, _c;
        const target = event.target;
        if ((_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))
            return;
        // Hack. Not close if internal popup change view on date click
        if ((_c = (_b = target === null || target === void 0 ? void 0 : target.className) === null || _b === void 0 ? void 0 : _b.includes) === null || _c === void 0 ? void 0 : _c.call(_b, 'DayPicker-Day--selected'))
            return;
        callback();
    };
    (0, react_1.useEffect)(() => {
        const handle = (event) => handleOutsideClickRef.current(event);
        document.addEventListener('click', handle);
        return () => document.removeEventListener('click', handle);
    }, []);
    return { rootRef };
};
exports.useOutDateRangeClick = useOutDateRangeClick;
//# sourceMappingURL=useOutDateRangeClick.js.map